import api from 'api';

import type { NextPageContext } from 'next';
import type { GetCompetencyProfilesRes } from 'shared-types/responses';

interface GetCompetencyProfilePageDataParams {
  profileId: string;
  req?: NextPageContext['req'];
}

interface GetCompetencyProfilePageDataResult {
  categories: GetCompetencyProfilesRes['categories'];
  competencyProfile: GetCompetencyProfilesRes['competencyProfiles'][0];
}

const getCompetencyProfilePageData = async ({
  profileId,
  req
}: GetCompetencyProfilePageDataParams): Promise<GetCompetencyProfilePageDataResult | null> => {
  try {
    const headers = req ? { Cookie: req.headers.cookie } : {};
    const response = await api.get<GetCompetencyProfilesRes>(
      `/admin/competency-profiles?profileId=${profileId}`,
      { headers }
    );
    if (
      !response.data.competencyProfiles ||
      !response.data.competencyProfiles.length
    ) {
      const error = new Error() as Error & { response: { status: number } };
      error.response = { status: 404 };
      throw error;
    }
    return {
      categories: response.data.categories,
      competencyProfile: response.data.competencyProfiles[0]
    };
  } catch (error) {
    return null;
  }
};

export default getCompetencyProfilePageData;
